import { IEnumValue, IMDMUnit, IPassportSchemaField } from '@/pages/MDM/mdm.types.ts'
import TextInput from '@/shared/Inputs/TextInput'
import TextArea from '@/shared/Inputs/TextArea'
import NumberInput from '@/shared/Inputs/NumberInput'
import UnitInstanceDropdown from '@/pages/MDM/components/Units/UnitInstanceDropdown'
import PrimitiveValueDropdown from '@/pages/MDM/components/Primitives/PrimitiveValueDropdown'
import Toggle from '@/shared/Inputs/Toggle'
import DatePicker from '@/shared/Inputs/DatePickers/DatePicker'

interface IProps {
  value: string
  schema: IPassportSchemaField
  name: string
  placeHolder?: string
  onChange: (val: string, name: string) => void
  onUnitValueChange: (val: IMDMUnit['id'], name: string) => void
  onEnumValueChange: (val: IEnumValue['id'], name: string) => void
}

const MDMValueInput = (props: IProps) => {
  const renderInput = () => {
    switch (props.schema.type) {
      case 'STRING':
        return (
          <TextInput value={props.value} name={props.name} onChange={props.onChange} placeHolder={props.placeHolder} />
        )
      case 'TEXT':
        return (
          <TextArea value={props.value} name={props.name} onChange={props.onChange} placeHolder={props.placeHolder} />
        )
      case 'NUMERIC':
        return (
          <NumberInput
            placeHolder={props.placeHolder}
            value={+props.value}
            name={props.name}
            fullWidth={true}
            onChange={(val, name) => props.onChange(val.toString(), name)}
          />
        )
      case 'UNIT':
        return (
          <UnitInstanceDropdown
            placeHolder={props.placeHolder}
            unitId={props.schema.typeUnitId}
            value={+props.value}
            name={props.name}
            onChange={(val) => props.onUnitValueChange(val, props.name)}
          />
        )
      case 'ENUM':
        return (
          <PrimitiveValueDropdown
            placeHolder={props.placeHolder}
            primitiveId={props.schema.typeEnumId}
            value={+props.value}
            name={props.name}
            onChange={(val) => props.onEnumValueChange(val, props.name)}
          />
        )
      case 'BOOLEAN':
        return (
          <Toggle
            name={props.name}
            checked={props.value === 'true'}
            onChange={(val) => props.onChange(val.toString(), props.name)}
            size="large"
          />
        )
      case 'DATE':
        return (
          <DatePicker
            value={safeDate(props.value)}
            onChange={(date) => props.onChange((date as Date).toISOString(), props.name)}
            type="date"
          />
        )
    }
  }

  return renderInput()
}

const safeDate = (value: string) => {
  try {
    const dt = new Date(value)
    if (dt.toString() === 'Invalid Date') {
      return new Date()
    }

    return dt
  } catch (_) {
    return new Date()
  }
}

export default MDMValueInput
